import { useEffect, useRef } from 'react';

export default function ChatApp() {
  const containerRef = useRef(null);

  useEffect(() => {
    const key = import.meta.env.VITE_PERNOEX_PUBLIC_KEY;

    if (!key) {
      console.warn('Pernoex public key not found. Set VITE_PERNOEX_PUBLIC_KEY in your environment.');
      return;
    }

    const script = document.createElement('script');
    script.src = 'https://cdn.pernoex.com/widget.js';
    script.setAttribute('data-manual-init', 'true');
    document.body.appendChild(script);

    script.onload = () => {
      window.Pernoex.init({
        apiKey: key,
        mode: 'embedded',
        container: containerRef.current,
        showHeader: false,
        showBranding: false,
        borderRadius: '8px',
        onReady: () => console.log('Pernoex widget ready'),
        onError: (err) => console.error('Pernoex init error:', err),
      });
    };

    return () => {
      window.Pernoex?.destroy();
      document.body.removeChild(script);
    };
  }, []);

  return (
    <div
      id="chat-container"
      ref={containerRef}
      style={{ flex: 1, display: 'flex', flexDirection: 'column', minHeight: 0 }}
    />
  );
}